/** Normalize nekoapi list endpoints (bare array or DRF-style envelope). */
export function parseNekoApiListArray(data) {
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object") {
    if (Array.isArray(data.results)) return data.results;
    if (Array.isArray(data.data)) return data.data;
  }
  return [];
}
